import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { Provider } from 'react-redux'
import { store } from './store/store'

import '@scuf/common/honeywell-compact-combined/theme.css'
import '@scuf/charts/honeywell-compact-combined/theme.css'
//import "@scuf/datatable/honeywell-compact-combined/theme.css";

import Layout from './pages/Layout/Layout'
import Login from './pages/Login/Login'
import Infraestructura from './pages/Infraestructura/Infraestructura';
import Process from './pages/Process/Process'
import APC from './pages/APC/APC'
import Diario from './pages/Diario/Diario';

const RouteConfig = () => {

  const PrivateRoute = ({ children, ...rest }) => {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          true ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
        }
      />
    );
  }

  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route path="/" exact>
            <Login />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <PrivateRoute path="/Infraestructura">
            <Layout route='Infraestructura' component={<Infraestructura></Infraestructura>} />
          </PrivateRoute>
          <PrivateRoute path="/procesos">
            <Layout route='procesos' component={<Process></Process>} />
          </PrivateRoute>
          <PrivateRoute path="/apc">
            <Layout route='apc' component={<APC></APC>} />
          </PrivateRoute>
          <PrivateRoute path="/diario">
            <Layout route='diario' component={<Diario></Diario>} />
          </PrivateRoute>
        </Switch>
      </Router>
    </Provider>

  )
}

export default RouteConfig
